import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
	standalone: false,
	selector: 'ngx-restaurant-changed-dialog',
	template: `
		<div class="restaurant-changed-dialog">
			<p class="restaurant-changed-dialog__message" translate>
				Le restaurant actif a été modifié dans un autre onglet. Rechargez la page pour afficher les données à jour.
			</p>
			<p class="restaurant-changed-dialog__restaurant" *ngIf="restaurantName">
				<span translate>Restaurant sélectionné</span>
				<strong>{{ restaurantName }}</strong>
			</p>
			<p-button
				(onClick)="reload()"
				severity="primary"
				type="button"
				icon="pi pi-refresh"
				[label]="'Recharger la page' | translate" />
		</div>
	`,
	styles: [
		`
			.restaurant-changed-dialog {
				display: flex;
				flex-direction: column;
				gap: 1rem;
				padding: 1.25rem;
			}

			.restaurant-changed-dialog__message {
				margin: 0;
				line-height: 1.5;
			}

			.restaurant-changed-dialog__restaurant {
				margin: 0;
				font-size: 0.875rem;
				color: var(--p-text-muted-color);

				strong {
					display: block;
					margin-top: 0.25rem;
					font-size: 1rem;
					color: var(--p-text-color);
				}
			}
		`,
	],
})
export class RestaurantChangedDialogComponent {
	restaurantName = '';

	constructor(
		private ref: DynamicDialogRef,
		config: DynamicDialogConfig,
	) {
		this.restaurantName = config.data?.restaurantName ?? '';
	}

	reload(): void {
		this.ref.close('reloaded');
		window.location.reload();
	}
}
